(() => {
  const roots = () => document.querySelectorAll('[data-nx01-purchase]');

  const readSelected = (root) => {
    const selected = root.querySelector('input[data-nx01-tier]:checked');
    if (!selected) return null;
    return {
      tier: selected.getAttribute('data-nx01-tier'),
      qty: selected.getAttribute('data-nx01-qty') || '1',
      plan: selected.getAttribute('data-nx01-plan') || '',
      priceHtml: selected.getAttribute('data-nx01-price-html') || '',
      priceText: selected.getAttribute('data-nx01-price-text') || '',
      daily: selected.getAttribute('data-nx01-daily') || '',
    };
  };

  const applyState = (state) => {
    if (!state) return;
    roots().forEach((root) => {
      const radio = root.querySelector(`input[data-nx01-tier="${state.tier}"]`);
      if (radio && radio.checked === false) radio.checked = true;
      const qty = root.querySelector('[data-nx01-quantity]');
      const plan = root.querySelector('[data-nx01-selling-plan]');
      const price = root.querySelector('[data-nx01-price-label]');
      const daily = root.querySelector('[data-nx01-daily-label]');
      const cart = root.querySelector('[data-nx01-cart-add]');
      if (qty) qty.value = state.qty;
      if (plan) plan.value = state.plan;
      if (price && state.priceHtml) price.innerHTML = state.priceHtml;
      if (daily && state.daily) daily.textContent = state.daily;
      if (cart) cart.setAttribute('xo-product-quantity', state.qty);
    });
    document.querySelectorAll('[data-nx01-sticky-price]').forEach((el) => {
      el.textContent = state.priceText;
    });
  };

  const bindRoot = (root) => {
    if (root.dataset.nx01Bound === 'true') return;
    root.dataset.nx01Bound = 'true';
    root.querySelectorAll('input[data-nx01-tier]').forEach((input) => {
      input.addEventListener('change', () => {
        applyState(readSelected(root));
      });
    });
  };

  const submitPrimary = () => {
    const form = document.querySelector('[data-nx01-purchase] .nx01-purchase__form');
    if (!form) return;
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
      return;
    }
    form.submit();
  };

  const start = () => {
    roots().forEach(bindRoot);
    const first = document.querySelector('[data-nx01-purchase]');
    if (first) applyState(readSelected(first));
    document.querySelectorAll('[data-nx01-sticky-submit]').forEach((button) => {
      if (button.dataset.nx01Bound === 'true') return;
      button.dataset.nx01Bound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        submitPrimary();
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', start);
})();
